document.addEventListener('click', e => {
    const form = document.querySelector('form#jsCallRequestForm');

    if (form) {
        const wrapper = form.closest('.modal-content');
        const button = wrapper.querySelector('button[type="submit"]');

        if (e.target === button) {
            ym(137454, 'reachGoal', 'selection_a_specialist')
        }
    }
})
document.addEventListener('click', e => {
    const form = document.querySelector('#callRequestForm');

    if (form) {
        const wrapper = form.closest('.modal-content');
        const button = wrapper.querySelector('button[type="submit"]');

        if (e.target === button) {
            ym(137454, 'reachGoal', 'order_a_callback')
        }
    }
})
document.addEventListener('click', e => {
    const form = document.querySelector('#buyOneClickModalForm');

    if (form) {
        const wrapper = form.closest('.modal-content');
        const button = wrapper.querySelector('button[type="submit"]');

        if (e.target === button) {
            ym(137454, 'reachGoal', 'buy_in_1_click_new_site')
        }
    }
})
document.addEventListener('click', e => {
    const form = document.querySelector('#directorForm');

    if (form) {
        const wrapper = form.closest('.modal-content');
        const button = wrapper.querySelector('button[type="submit"]');

        if (e.target === button) {
            ym(137454, 'reachGoal', 'feedback_form')

            const phone = form.querySelector('input[name="CallRequests[phone]"]').value;
            const name = form.querySelector('input[name="CallRequests[name]"]').value;

            // const callTrackingParams = window.ct('calltracking_params', 'z1wkxf1n');
            // if (callTrackingParams && callTrackingParams.sessionId) {
            //     const sessionId = callTrackingParams.sessionId;
            //     console.log('Session ID:', sessionId);
            // } else {
            //     console.error('Не удалось получить sessionId');
            // }

            // const ct_data = {
            //     siteId: 72355,
            //     fio: 'Иванов Иван Иванович',
            //     phoneNumber: '79000000000',
            //     email: 'test@test.ru',
            //     subject: 'Заявка с сайта',
            //     tags: 'Mercedes,Белый',
            //     comment: 'Тест-драйв',
            //     requestUrl: location.href,
            //     sessionId: window.ct('getSessionData','z1wkxf1n').sessionId
            // };
            //
            // ct('sendEvent', {
            //     event: 'click',
            //     data: ct_data
            // });
        }
    }
})


const debounceFn = (fn, ms) => {
    let timer = null;
    const clear = () => {
        if (!timer) return;
        clearTimeout(timer);
        timer = null;
    };
    const callback = (...args) => {
        clear();
        timer = setTimeout(fn.bind(null, ...args), ms);
    };
    callback.drop = clear;
    return callback;
};

// Футер
(() => {
    const limit = 7;

    const footerLinksGroups = document.querySelectorAll(
        ".accordion-body--footer"
    );
    for (const group of footerLinksGroups) {
        const links = group.querySelectorAll(".accordion-link--footer");
        if (links.length <= limit) {
            group.classList.add("full");
        } else {
            const button = document.createElement("button");
            button.classList.add("accordion-show-button");
            button.innerText = "еще " + (links.length - limit + 1);
            button?.addEventListener("click", () => {
                group.classList.add("full");
            });
            group.appendChild(button);
        }
    }
})();

//TODO: Доделать модалку каталога
// Модальное окно каталога
// (() => {
//   const limit = 9;
//   const removeActiveClass = (el) => el.classList.remove("active");
//   const modalCatalogLinks = document.querySelectorAll("#modalCatalogNav a");
//   const modalCatalogSections = document.querySelectorAll(
//     "#modalCatalogMain .modalCatalogSection"
//   );
//   const modalCatalogSectionsSubcategories = document.querySelectorAll(
//     "#modalCatalogMain .modalCatalogSection_subcategories"
//   );
//   const modalCatalog = document.querySelector("#modalCatalog");
//   const modalCatalogWrapper = document.querySelector("#modalCatalogWrapper");
//   const openModalCatalogBtn = document.querySelector(
//     "#openModalCatalogBtn"
//   );
//
//   const changeActiveCategory = (e) => {
//     const element = e.target;
//     const isActive = element.classList.contains("active");
//     if (isActive) return;
//     modalCatalogLinks.forEach(removeActiveClass);
//     modalCatalogSections.forEach(removeActiveClass);
//     element.classList.add("active");
//     const target = element.getAttribute("data-target");
//     document.querySelector(target)?.classList.add("active");
//   };
//
//
//   const openCatalog = () => {
//     const isActive = modalCatalog.classList.contains("active");
//     openModalCatalogBtn.blur();
//     if (!isActive) {
//       disableBodyScroll();
//       modalCatalog.classList.add("active");
//     }
//   };
//
//   const closeCatalog = () => {
//     enableBodyScroll();
//     modalCatalog.classList.remove("active");
//   };
//
//   const callbackActiveCategory = debounceFn(changeActiveCategory, 300);
//   const callbackOpen = debounceFn(openCatalog, 300);
//   const callbackClose = debounceFn(closeCatalog, 300);
//
//   openModalCatalogBtn.addEventListener("mouseenter", () => {
//     callbackClose.drop();
//     callbackOpen();
//   });
//   openModalCatalogBtn.addEventListener("mouseleave", () => {
//     callbackClose();
//     callbackOpen.drop();
//   });
//
//   modalCatalogWrapper.addEventListener("mouseenter", () => {
//     callbackClose.drop();
//   });
//   modalCatalogWrapper.addEventListener("mouseleave", () => {
//     callbackClose();
//     callbackOpen.drop();
//   });
//
//   modalCatalogLinks.forEach((link) => {
//     link.addEventListener("mouseenter", callbackActiveCategory);
//     link.addEventListener("mouseleave", callbackActiveCategory.drop);
//   });
//
//   for (const group of modalCatalogSectionsSubcategories) {
//     const links = group.querySelectorAll(".modalCatalogSection_subcategory");
//     if (links.length <= limit) {
//       group.classList.add("full");
//     } else {
//       const button = document.createElement("button");
//       button.classList.add("btn-secondary", "modalCatalogSection_toggle");
//       button.innerText = "Показать ещё";
//       button?.addEventListener("click", () => {
//         group.classList.add("full");
//       });
//       group.appendChild(button);
//     }
//   }
// })();

// Навигация хедера
(() => {
    const navbar = document.getElementById("headerNavBar");
    let scrollY = 0;
    const offset = 10;

    function toggleFixedHeader() {
        if (!navbar) return;
        if (scrollY > window.scrollY + offset) {
            navbar.classList.remove("hidden");
            scrollY = window.scrollY <= 0 ? 0 : window.scrollY;
        } else if (scrollY < window.scrollY - offset) {
            navbar.classList.add("hidden");
            scrollY = window.scrollY <= 0 ? 0 : window.scrollY;
        }
    }

    new Swiper("#navSwiper", {
        speed: 300,
        spaceBetween: 0,
        slidesPerView: "auto",
        navigation: {
            nextEl: "#navSwiperNext",
            prevEl: "#navSwiperPrev",
        },
    });

    window?.addEventListener("scroll", toggleFixedHeader);
})();


// Открытие Viber
(() => {
    function openViber(url) {
        const timeout = setTimeout(function () {
            window.location.href = "https://www.viber.com/";
            window.removeEventListener("blur", clear);
        }, 500);
        window.location.href = url;
        window.addEventListener("blur", clear, {once: true});

        function clear() {
            clearTimeout(timeout);
        };
    }

    const links = document.querySelectorAll("[data-viber]");
    links.forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            const url = e.currentTarget.href;
            openViber(url);
        });
    });
})();

function truncate(selector) {
    // ".employeePreview_description"
    $(selector)?.dotdotdot({
        height: "watch",
        watch: "window",
    });
}

function checkMobile(breakpoint) {
    return window.innerWidth <= breakpoint;
}

function disableBodyScroll() {
    const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = scrollBarWidth + "px";
}

function enableBodyScroll() {
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
}

function modalToggler(e) {
    const target = e.target
        .closest("[data-modal-target]")
        ?.getAttribute("data-modal-target");
    if (!target) return;
    const className =
        e.target.closest("[data-class]")?.getAttribute("data-class") ?? "open";
    const modal = document.getElementById(target);
    if (!modal) return;
    const isOpened = modal.classList.contains(className);
    if (!isOpened) {
        modal.classList.add(className);
        disableBodyScroll();
    } else {
        modal.classList.remove(className);
        setTimeout(() => {
            enableBodyScroll();
        }, 300);
    }
}

function detectHorizontalScroll(element) {
    const scrollLeft = element.scrollLeft;
    if (scrollLeft === 0) {
        element.scrollLeft = 1;
    }
    const isScroll = element.scrollLeft !== 0;
    if (scrollLeft === 0) {
        element.scrollLeft = 0;
    }
    return isScroll;
}

const breakpoint = 920;
let isMobile = checkMobile(breakpoint);

function updateIsMobile() {
    const isMobileTemp = checkMobile(breakpoint);
    if ((!isMobile && isMobileTemp) || (isMobile && !isMobileTemp)) {
        isMobile = isMobileTemp;
    }
}

async function initYandexMap(viewId, params) {
    return new Promise((resolve, reject) => {
        ymaps.ready(
            () => {
                const instance = new ymaps.Map(viewId, params);
                resolve(instance);
            },
            () => reject("ymaps load error")
        );
    });
}

window.addEventListener("resize", updateIsMobile);

document.addEventListener("click", modalToggler);

function showAutoselectionButton(ajaxResults) {
    let button = $(".js-autoselection-show-button");
    let buttonText = "Показать";

    if (!ajaxResults) {
        button.attr("disabled", "disabled").text("Показать");
    } else if (ajaxResults.amount > 0) {
        button.removeAttr("disabled");
        buttonText =
            'Показать<span class="badge badge--filter-button rounded-pill bg-secondary mx-2 my-auto ">' +
            ajaxResults.amount +
            "</span>";
    } else {
        button.attr("disabled", "disabled");
        buttonText = "Нет результатов";
    }

    button.html(buttonText);
}

function generateHash(formData) {
    return MD5(formData).toString();
}

function formHasChanged(hash_key, formData) {
    let originalHash = localStorage.getItem(hash_key);
    let currentHash = generateHash(formData);

    if (originalHash !== currentHash) {
        localStorage.setItem(hash_key, currentHash);
        return true;
    }

    return false;
}

/*Full Line Code Completion is a built-in plugin that enhances code completion with inline suggestions. The plugin uses only local LLMs and does not send any of your data over the internet.  Full Line Code Completion offers an LLM for JavaScript. Would you like to download this model?*/

(() => {
    try {
        const servicesContainer = document.querySelector('#maintenanceServices');
        const servicesCount = servicesContainer?.children.length ?? 0;
        if (servicesCount <= 9) {
            servicesContainer.parentNode.classList.add('full');
        }
        const btn = document.querySelector('#showAllServices');
        btn.addEventListener('click', () => {
            btn.parentNode.classList.add('full');
        });
    } catch (e) {
    }
})();


function updateQuantity(data) {
    let bagde = $('#badge-basket-header-button');
    if (bagde.length === 0) {
        let span = document.createElement('span');
        $(span).addClass('badge badge--button bg-success rounded-circle').attr('id', 'badge-basket-header-button')
            .html(data)
            .appendTo($('.js-cart-button'))
    } else {
        bagde.text(data);
    }
}

function ajaxUpdateQuantity() {
    $.ajax({
        url: '/api/basket/quantity'
    }).done(function (data) {
        updateQuantity(data);
    });
}

function updatePopularSection(mainGroup) {

    let popularContainer = $('#productsWidgetSwiperWrapper');

    if (popularContainer.length > 0) {

        $.ajax({
            url: '/catalog/ajax/popular-by-category',
            data: {
                main_group: mainGroup
            }
        }).done(
            function (result) {
                $('#productsWidgetSwiperWrapper').html(result);
            }
        );

        let dataAtt = '[data-main-group="' + mainGroup + '"]'
        $('.js-fast-link-main-group').removeClass('active');
        $(dataAtt).addClass('active');
    }
}

document.addEventListener('click', e => {
    const modal = e.target.closest('.modal-dialog--citiesModal');

    if (modal) {
        const btn = modal.querySelector('[data-bs-dismiss="modal"]');

        if (e.target === btn) {
            const currentCity = modal.querySelector('.citiesModal_title').innerText;
            const cityList = document.querySelector('.citiesModal_list#chooseCitiesModalList').querySelectorAll('a');

            cityList.forEach(city => {
                const regex = new RegExp(city.innerText, 'i');

                if (currentCity.search(regex) > -1) {
                    city.click();
                }
            })
        }
    }
})


document.addEventListener('click', e => {
    const btn = e.target.closest('[data-about-reasons-show-map]');

    if (btn) {
        const map = document.querySelector('.section-with-map');

        map.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
})

